//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import { Dialog, Toast } from 'vant'
import { fetch } from '@/page/index'
import SrmCommonUtils from '@/utils/SrmCommonUtils'
import MergeTable from '../pendingApproval/components/MergeTable.vue'
import FileListModel from '../pendingApproval/components/FileListModel.vue'

export default {
  name: 'DeliveryNoteDetail',
  components: {
    MergeTable,
    FileListModel,
  },
  data () {
    return {
      activeName: ['1', '2', '3'],
      noteHeaderId: null,
      headerInfo: {},
      lineList: [],
      docData: [],
      loading: false,
      selectedUnbindLineIds: [],
      unbinding: false,
    }
  },
  computed: {
    ...mapState({
      languageCode: (state) => state.user.languageCode,
    }),
    boundLineOptions () {
      return (this.lineList || []).filter((item) => {
        const qty = item.barcodeQty == null ? 0 : Number(item.barcodeQty)
        return qty > 0
      })
    },
    lineColumns () {
      const self = this
      const center = { align: 'center' }
      return [
        {
          label: '行状态',
          prop: 'noteLineStatus',
          width: 100,
          ...center,
          formatter: (v) => self.lookup('PUR_DEL_ORDER_LINE_STATUS', v),
        },
        { label: '物料编码', prop: 'itemCode', width: 120, ...center },
        { label: '物料描述', prop: 'itemName', width: 140, ...center, showToast: true },
        {
          label: '单位',
          prop: 'uomCode',
          width: 70,
          ...center,
          formatter: (v) => self.lookup('BASE_UNIT', v),
        },
        { label: '到料计划数量', prop: 'noticeDeliveryQty', width: 110, ...center },
        { label: '可建送货单数量', prop: 'usableDeliveryQty', width: 110, ...center },
        { label: '本次送货数量', prop: 'deliveryQty', width: 110, required: true, ...center },
        { label: '已绑定标签数量', prop: 'barcodeQty', width: 110, ...center },
        { label: '已入库数量', prop: 'putStorageQty', width: 110, ...center },
        { label: '库存地点', prop: 'storageLocation', width: 100, ...center },
        { label: '到料计划单号', prop: 'noticeNum', width: 120, ...center, showToast: true },
        { label: '到料计划行号', prop: 'noticeLineNumber', width: 100, ...center },
        { label: '订单号', prop: 'poNum', width: 120, ...center, showToast: true },
        { label: '集采关联订单号', prop: 'centralizedPoNum', width: 120, ...center, showToast: true },
        { label: '订单行号', prop: 'poLineNumber', width: 90, ...center },
        { label: '订单数量', prop: 'orderQty', width: 100, ...center },
        { label: '备注', prop: 'remark', width: 120, ...center, showToast: true },
      ]
    },
  },
  created () {
    this.noteHeaderId = this.$route.query.noteHeaderId
    this.loadDetail()
  },
  methods: {
    dv (v) {
      if (v === null || v === undefined || v === '') return '-'
      return String(v)
    },
    lookup (type, v) {
      if (v === null || v === undefined || v === '') return '-'
      const t = new SrmCommonUtils(this).getLookupMeaning(type, v)
      return t != null && t !== '' ? t : String(v)
    },
    isResOk (res) {
      return res && (res.code === '200' || res.code === 200 || res.status === 'S')
    },
    showFileDetail (fileIds) {
      fetch.v2ListBaseFile({
        lan: this.languageCode,
        ids: fileIds,
      }).then((resp) => {
        this.docData = (resp && resp.data) || []
        this.$refs.fileListModelRef.showFileModel = true
      })
    },
    toggleUnbindLine (noteLineId) {
      const idx = this.selectedUnbindLineIds.indexOf(noteLineId)
      if (idx > -1) {
        this.selectedUnbindLineIds.splice(idx, 1)
      } else {
        this.selectedUnbindLineIds.push(noteLineId)
      }
    },
    confirmUnbind () {
      if (!this.selectedUnbindLineIds.length) return
      Dialog.confirm({
        title: '确认解绑',
        message: '确认解绑所选送货单行的全部标签？解绑后将清除标签上的送货单号和行号。',
      }).then(() => {
        this.unbinding = true
        fetch.srmPurLabelManage_doUnbindDeliveryNote({
          lan: this.languageCode || 'CN',
          noteLineIdList: this.selectedUnbindLineIds,
        }).then((res) => {
          if (!this.isResOk(res)) {
            Toast.fail((res && res.msg) || '解绑失败')
            return
          }
          Toast.success('解绑成功')
          this.selectedUnbindLineIds = []
          this.loadDetail()
        }).catch((err) => {
          Toast.fail((err && err.msg) || (err && err.message) || '解绑失败')
        }).finally(() => {
          this.unbinding = false
        })
      }).catch(() => {})
    },
    loadDetail () {
      if (!this.noteHeaderId) {
        this.$toast && this.$toast('缺少送货单ID')
        return
      }
      this.loading = true
      const lan = this.languageCode || 'CN'
      const headerParams = { lan, noteHeaderId: this.noteHeaderId }
      const lineParams = {
        lan,
        noteHeaderId: this.noteHeaderId,
        pageIndex: 1,
        pageRows: 500,
      }
      Promise.all([
        fetch.srmPurDeliveryNoteHeader_findById(headerParams),
        fetch.srmPurDeliveryNoteLine_listByPage(lineParams),
      ])
        .then(([headerRes, lineRes]) => {
          if (this.isResOk(headerRes) && headerRes.data) {
            this.headerInfo = headerRes.data
          } else {
            this.headerInfo = {}
            this.$toast && this.$toast((headerRes && headerRes.msg) || '加载头信息失败')
          }
          if (this.isResOk(lineRes)) {
            this.lineList = Array.isArray(lineRes.data) ? lineRes.data : []
          } else {
            this.lineList = []
          }
        })
        .catch(() => {
          this.headerInfo = {}
          this.lineList = []
          this.$toast && this.$toast('网络异常')
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}



// WEBPACK FOOTER //
// ./src/page/srm/delivery/delivery.vue